import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.scss']
})
export class RecoverComponent implements OnInit {
  public recoverForm: FormGroup;
  public complete = false;
  constructor(private accountService: AccountService) {
    this.recoverForm = new FormGroup({
      'email': new FormControl('', [
        Validators.email,
        Validators.required
      ])
    });
  }

  ngOnInit() {
  }

  recover(){
    this.accountService.recoverAccount(this.recoverForm.get('email').value).subscribe(res=>{
      this.complete = true;
    })
  }

}
